export default "__VITE_ASSET__B2ag_yk5__"